import axios from 'axios';

const API_PATH = `${process.env.VUE_APP_FRONT_API}${process.env.VUE_APP_FRONT_FAVORITE}`;

export const getFavorite = () => axios.get(API_PATH);
